// extracted by mini-css-extract-plugin
export default {"header":"Communication_header__tF37F","name":"Communication_name__n6zSf","total":"Communication_total__EtZhT","img":"Communication_img__chVu1"};